
import { SaleLayoutFreeLinePlacement } from "@/utils/sale-layouts/free-line";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
export default Vue.extend({
	props: {
		value: {
			type: String as ()=>SaleLayoutFreeLinePlacement
		},
		label: {
			type: [String, Object as ()=>{toString():string}]
		},
		fancy: Boolean,
		includeNone: Boolean
	},
	computed: {
		items():ISelectItem<SaleLayoutFreeLinePlacement>[]{
			let result:ISelectItem<SaleLayoutFreeLinePlacement>[] = [
				{
					text: this.$ct("above-table"),
					value: "AboveTable"
				},
				{
					text: this.$ct("after-detail"),
					value: "AfterDetail"
				},
				{
					text: this.$ct("totals"),
					value: "Totals"
				}
			];

			if (this.includeNone){
				result.unshift({
					text: this.$ct("common.none"),
					value: ""
				});
			}

			return result;
		}
	},
	methods: {
		onInput(event:SaleLayoutFreeLinePlacement){
			this.$emit("input", event);
		}
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
